import T from '@wojtekmaj/react-t';

import { Small } from './marketing_disclaimers.styles';

export default function MarketingDisclaimers() {
  return (
    <Small>
      <T>
        You can change your marketing consents anytime in the Marketing consents tab in your
        profile.
      </T>
    </Small>
  );
}
